export interface ChatSelectionDocument {
    id: string;
    name: string;
}

export interface ChatSelectionContext {
    text: string;
    dataIds: readonly string[];
    document?: ChatSelectionDocument;
}

/** 管理下一条聊天消息使用的编辑器选择上下文。 */
export interface ChatSelectionContextService {
    /**
     * 替换待发送的选择上下文。
     * @param context 编辑器选择上下文
     */
    set(context: ChatSelectionContext): void;

    /**
     * 获取当前待发送上下文。
     * @returns 当前上下文；尚未设置时返回 null
     */
    get(): ChatSelectionContext | null;

    /** 在消息发送成功后清除上下文。 */
    clear(): void;
}

/** application scope 内存实现，不依赖 Vue 响应式状态。 */
export class InMemoryChatSelectionContextService implements ChatSelectionContextService {
    private context: ChatSelectionContext | null = null;

    set(context: ChatSelectionContext): void {
        this.context = {
            ...context,
            dataIds: [...context.dataIds],
            document: context.document ? { ...context.document } : undefined,
        };
    }

    get(): ChatSelectionContext | null {
        if (!this.context) return null;
        return {
            ...this.context,
            dataIds: [...this.context.dataIds],
            document: this.context.document ? { ...this.context.document } : undefined,
        };
    }

    clear(): void {
        this.context = null;
    }
}
